import SimpleQuestion from "./SimpleQuestion";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import { getLanguageCode } from "../store/components";
import { PlatinumOptions } from "./SingleSelectPlatinum";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import * as theme from "../theme";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import { useStylesLocally } from "../muithemeclasses";
import { getBrokerInformation } from "../store/broker";

const SingleSelect = ({
  text,
  node,
  handleAnswerChange,
  isNodeOpen,
  qfusermode,
}) => {
  let boxlist = false;

  if (node?.logic?.boxlist) boxlist = true;
  return (
    <SimpleQuestion
      boxlist={boxlist}
      node={node}
      leftString={text}
      rightComponent={
        boxlist ? (
          <PlatinumOptions
            handleAnswerChange={handleAnswerChange}
            node={node}
            nodescription={true}
            qfusermode={qfusermode}
          ></PlatinumOptions>
        ) : (
          <SingleSelectDropDown
            node={node}
            handleAnswerChange={handleAnswerChange}
            qfusermode={qfusermode}
          ></SingleSelectDropDown>
        )
      }
    ></SimpleQuestion>
  );
};

const SingleSelectDropDown = ({ node, handleAnswerChange, qfusermode }) => {
  const languagecode = useSelector(getLanguageCode);
  let brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo.information.languagepreference;
  const handleAnswer = (event, value) => {
    handleAnswerChange(value);
  };
  const classes = useStylesLocally();
  return (
    <Autocomplete
      id={`singleSelect_${node.id}`}
      disabled={qfusermode === INSURER ? true : false}
      options={node.logic.options}
      getOptionLabel={(option) =>
        option.text?.[languagepreference]
          ? option.text[languagepreference]
          : null
      }
      onChange={handleAnswer}
      value={node.answer}
      classes={{
        root: classes.root,
        listbox: classes.listbox,
        input: classes.input,
      }}
      style={{ fontFamily: "GibsonSemiBd" }}
      renderInput={(params) => (
        <TextField
          {...params}
          classes={{
            root: classes.textFieldRoot,
          }}
          // onFocus={() => {
          //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
          //     helpTipPB.VerticalHelpOrTipFncs.changeText(
          //       this.props.questionHint
          //     );
          //   }
          // }}
          // onBlur={() => {
          //   if (helpTipPB.VerticalHelpOrTipFncs.changeText) {
          //     helpTipPB.VerticalHelpOrTipFncs.changeText("");
          //   }
          // }}
        />
      )}
    />
  );
};

export default SingleSelect;
